import { Flex, Link } from "basis";
import { getRegional } from "library/getRegional";
import { useEventTracking } from "react-event-tracker";
import { SvgInline } from "../SvgInline/SvgInline";
import styles from "./homepage.module.scss";

export const HomePageHeader = () => {
  const { trackEvent } = useEventTracking();
  return (
    <header className={`${styles.header} ${styles.container}`}>
      <SvgInline
        name={getRegional("logo")}
        style={{ width: getRegional("code") === "NZ" ? "85px" : "149px" }}
        className={styles.latitudeLogo}
      />
      <Link
        href="/faq"
        data-testid="header-help"
        newTab={false}
        onClick={() =>
          trackEvent({
            event: {
              category: "text-link",
              action: "internal-link",
              location: "login-header",
              label: "Help",
            },
          })
        }
      >
        <Flex placeItems="center">
          <SvgInline name="icon-question" className={styles.helpIcon} />
          Help
        </Flex>
      </Link>
    </header>
  );
};
